module.exports = __webpack_public_path__ + "static/media/26-5.a4853e35.mp3";